<!-- bottom cookie banner -->
@if (cookieBanner$ | async; as cookieBanner) {
    <h-cookie-banner [cookieBanner]="cookieBanner" (closeBanner)="closeCookieBanner()" />
}

@if (!isNewNotificationBannerEnable()) {
    @if (notificationsBanners$ | async; as notificationsBanners) {
        <h-notification-banner
            class="header-notifications"
            [notificationsBanners]="notificationsBanners"
            (closeBanner)="closeNotificationsBanner()" />
    }
}
